import { useParams } from 'react-router-dom';

import { CaseSelector } from '@/modules/case-selector';

/**
 * Case selection page that displays cases for a specific masterclass.
 *
 * Route behavior:
 * - /masterclass/:masterclassId/cases - loads cases from GraphQL
 * - /cases (legacy) - uses static fallback config
 *
 * Both routes remain functional for backward compatibility.
 * The static fallback will be removed once dynamic loading is fully verified.
 */
export default function CaseSelection() {
  const { masterclassId } = useParams<{ masterclassId: string }>();

  if (!masterclassId) {
    throw new Error('masterclassId is required in the URL parameters.');
  }
  return <CaseSelector masterclassId={masterclassId} />;
}
